import {useApi} from "../Api";
import {ExcessGroupDetail} from "../types/excessGroupDetail";

export const useExcessGroupDetailRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/excess-group-detail";

    function getExcessGroupMatrix(excessGroupId: number): Promise<ExcessGroupDetail[]> {
        return GET(`${PATH}/matrix?excessGroupId=${excessGroupId}`);
    }

    return {
        getExcessGroupMatrix
    };
};
